import React from "react";
import { useTranslation } from 'react-i18next';

const LoadPage = ({text}) => {
  const { t } = useTranslation();
  
  return (
    <div id="content">
      <div id="content-title">{t('loading')}..</div>

      <div className="clear-both" />

      <div>{text || (t('please_wait') + "...")}</div>
    </div>
  );
};

export default LoadPage;
